// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileImageOutlinedSvg from "@ant-design/icons-svg/es/asn/FileImageOutlined";
import AntdIcon from '../components/AntdIcon';

var FileImageOutlined = function FileImageOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileImageOutlinedSvg
  }));
};

FileImageOutlined.displayName = 'FileImageOutlined';
export default React.forwardRef(FileImageOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FileImageOutlined.js
// module id = 1111
// module chunks = 0